import { createSlice, createAction } from "@reduxjs/toolkit";

import { ItemFiltersModel } from "../model/item";

import { RootState } from "../store/store";

export const resetItemFilter = createAction("itemFilter/reset");

type SliceState = { value: ItemFiltersModel };
const initialState = {
  value: {
    suppliers: [],
    itemgroups: [],
    itemstatus: [],
    showOnlyItemInSO: false,
  },
} as SliceState;

export const itemFilterSlice = createSlice({
  name: "itemSOFilter",
  initialState,
  reducers: {
    updateSOFilter: (state, action) => {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetItemFilter, (n) => {
      return initialState;
    });
  },
});

export const { updateSOFilter } = itemFilterSlice.actions;

export const getItemSOFilter = (state: RootState) => state.itemSOFilter.value;

export default itemFilterSlice.reducer;
